exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 320px) {\n  body {\n    text-align: center;\n    justify-content: center;\n  }\n  .leftAlign {\n    justify-content: center;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .leftAlign {\n    text-align: left;\n    justify-content: flex-start;\n    margin: 50px 20px 50px 20px;\n  }\n  .description{\n    width: 50%;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .description{\n    width: 30%;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/views/Splash/responsive.css
// module id = ./node_modules/css-loader/index.js!./src/views/Splash/responsive.css
// module chunks = 0